try {
    // safety loader
    if(!window.$) {
        window.$ = window.jQuery = require('jquery');

    }
    if(!window.bodyScroll) {
        // scroll body lock: https://www.npmjs.com/package/body-scroll-toggle
        window.bodyScroll = require('body-scroll-toggle');
    }

    jQuery(document).ready(function($) {

        if($('[data-wdp-tabswitch-toggle]').length) {
            $('[data-wdp-tabswitch-toggle]').click( function( e ) {
                e.preventDefault();

                var toggle_value = $(this).data('wdp-tabswitch-toggle');

                $('[data-wdp-tabswitch-target]').removeClass('active');
                $('[data-wdp-tabswitch-target=' + toggle_value + ']').addClass('active');
            });
        }

        /*
        if ($('[data-country-link]').length && $('.wpg-wdp-productform-content form.iforms').length && !$('body').hasClass('wpm-iform-choose_payment')) {
            $('.wpg-wdp-productform-content form.iforms').prepend( $('[data-country-link]') );

            var country = $('[data-country-link]').data('country-link');
            if (country === "NL") {
                redirectToBelgiumForm();
            }
        }

        function redirectToBelgiumForm() {
            // get country and redirect to urlbased on that info
            var apiKey = '00a002eb7e6d7cc9b3e769fc7064eabb8dad87719dc67e155f3ef24a';
            $.get('https://api.ipdata.co?api-key='+apiKey, {
                dataType: 'json'
            })
            .done(function(data) {
                if(data.country_code == 'BE') {
                    // if your country is Belgium; switch to BE form
                    var new_url = $('[data-country-link] a').attr('href');
                    window.location.replace(new_url);
                }
            });
        }*/

        /*
		If there are digital products on the page
		
		if($('[data-wdp-product-id]').length) {

            $.ajax( {
				url      : wdpvars.ajaxurl,
				data     : {
					action : 'wdp_myproducts',
                    post_id : wdpvars.post_id,
                    extra_ids : true
				},
				type     : 'POST',
				dataType : 'json'
			} ).done( function ( result ) {

                // target to add the users products to
                var $target = $('[data-wdp-myproducts-target]');

                if (result.data.is_logged_in) {
                    $('.wpg-wdp-product').addClass('logged_in');
                }

                // user is logged in so hide login section and show myproducts section
                if (result.data.is_logged_in && $('[data-wdp-loggedin-target]').length) {

                    $('[data-wdp-loggedin-target="false"]').addClass('d-none');
                    $('[data-wdp-loggedin-target="true"]').addClass('d-block');
                }

                // user has no products so show message
				if (true !== result.success || undefined === result.data.posts) {
					$target.append( '<div class="col-12 wdp-no-products-message">' + result.data.noproductstext + '</div>' );
					return;
                }

                // add products to myproducts tab
                $target.append( result.data.posts );

                // // open myproducts tab //Commented out as it is, for now, no longer desired to lead users straight to the myproducts tab
                // if($('[data-wdp-tabswitch-toggle="myproducts"]').length) {
                //     $('[data-wdp-tabswitch-toggle="myproducts"]').click();
                // }

                // add user products to slider
                if (result.data.slider_posts && $('[data-wdp-loggedin]').length && $('[data-wdp-loggedin-target]').length) {
                    $('[data-wdp-loggedin-target]').append(result.data.slider_posts);
                    $('[data-wdp-loggedin]').show();
                    $(document).trigger('init-loggedin-slider');
                }

                // change button and hide elements for purchased products
                if (result.data.abos_ids) {
                    jQuery.each( result.data.abos_ids, function( i, val ) {
                        var $product = $('[data-wdp-product-id="' + val.abos_id + '"], [data-wdp-product-id-be="' + val.abos_id + '"]');
                        $product.addClass('purchased');
                        $product.find('[data-wdp-product-url]').attr('href', val.edition_url)
                        $product.find('[data-wdp-product-url-button]').text(result.data.buttontext);
                    });
                }
			} );
        }*/

        $('.wpg-wdp-text-read-toggle').on('click', function() {
            var contentWrap = $(this).parents('.wpg-wdp-text-read-content-wrapper');
            var shortContent = contentWrap.find('.wpg-wdp-text-read-short-content');
            var completeContent = contentWrap.find('.wpg-wdp-text-read-complete-content');

            if($(this).hasClass('wpg-wdp-text-read-more')) {
                shortContent.hide();
                completeContent.show();
            }

            if($(this).hasClass('wpg-wdp-text-read-less')) {
                completeContent.hide();
                shortContent.show();
            }
        });


        // update training sidebar price when there is a discount code
        $( document ).on( 'iform-kortingscode-value-updated', function(e){
            
            if (!$('.wpg-wdp-productform-sidebar-price-container').length) {
                return false;
            }

            var discount = $('#kortingscode-value').val();
            var subtotal = $('.field__wrapper--subtotaalbedrag .field__wrapper__input--subtotaalbedrag span').html();
            var total = $('input[type="hidden"].field--totaalbedrag').val();

            if (discount > 0) {
                discount = discount / 100;
            }

            // add the subtotal price above the total price
            addPriceToSidebar('subtotal', subtotal, 'Subtotaal', false);

            // add the discount price above the total price
            addPriceToSidebar('discount', discount, 'Korting', true);

            // change the total value
            $('.wpg-wdp-productform-sidebar-price-current').html(total);
        } );



        function addPriceToSidebar(name, value, label, negative_value) {

            if (!value || value == 0) {
                $('.wpg-wdp-productform-sidebar-' + name + '-container').remove();
                $('.wpg-wdp-productform-sidebar-price-from').show();
                return false;
            }

            // add the price above the total price
            if ($('.wpg-wdp-productform-sidebar-' + name + '-container').length) {
                if ( $.isNumeric(value) && value > 0) {
                    $('.wpg-wdp-productform-sidebar-' + name + '-container .wpg-wdp-productform-sidebar-' + name + '-price').html((negative_value ? '- ' : '') + '€ ' + value.toFixed( 2 ).toString().replace(".", ","));
                } else {
                    $('.wpg-wdp-productform-sidebar-' + name + '-container .wpg-wdp-productform-sidebar-' + name + '-price').html(value);
                }
            } else {
                $('.wpg-wdp-productform-sidebar-price-container').before(
                    '<div class="wpg-wdp-productform-sidebar-' + name + '-container">' +
                        '<div class="wpg-wdp-productform-sidebar-' + name + '-header">' + label + '</div>' +
                        '<div class="wpg-wdp-productform-sidebar-' + name + '-price">' +
                            (negative_value ? '- ' : '') + ( $.isNumeric(value) ? '€ ' + value.toFixed( 2 ).toString().replace(".", ",") : value) + 
                        '</div>' +
                    '</div>'
                );
            }

            $('.wpg-wdp-productform-sidebar-price-from').hide();
        }

        //show more experts on mobile on training detail
        $('.wpg-wdp-product-block-expert-more').on('click', function() {
            $('.wpg-wdp-expert-hide-mobile').toggleClass('show');
            $('.wpg-wdp-product-block-expert-more-container').toggleClass('show');
            if($('.wpg-wdp-expert-hide-mobile').hasClass('show')){
               $('.wpg-wdp-product-block-expert-more').text('Verberg experts');         
            } else {
                $('.wpg-wdp-product-block-expert-more').text('Toon alle experts');
            }
        });

        //show more content blocks on training detail
        $('.wpg-wdp-product-block-content-more').on('click', function() {
            $('.wpg-wdp-content-list-hide').toggleClass('show');
            $('.wpg-wdp-product-block-content-more-container').toggleClass('show');
            $('.wpg-wdp-hide-button-text').toggle();
            $('.wpg-wdp-show-button-text').toggle();
        });

        //replace iframe content with the same content to make sound stop after closing modal
        if ($('#product-detail-video-modal').length || $('#product-detail-video-modal-test').length) {
            $('body').on('hidden.bs.modal', function (e) {
                $('#product-detail-video-modal iframe').attr("src", $("#product-detail-video-modal iframe").attr("src"));
                $('#product-detail-video-modal-test iframe').attr("src", $("#product-detail-video-modal-test iframe").attr("src"));
            });
        }

        //open video on mobile after click on image
        if ($('.wpg-wdp-product-video-mobile').length) {
            $('.wpg-wdp-product-video-mobile').on('click', function(e) {
                e.preventDefault();
                $('.video-wrapper-mobile').toggle();
            });
        }

        function stickyBar() {
            var stickyDesktop = new Waypoint.Sticky({
                element: $( '.wpg-wdp-single-product-header' ),
                handler: function(direction) {
                    let selector = '.wpg-wdp-sticky-bar';
                    $(selector).toggleClass('stuck');

                    if ($(window).width() >= 1200) {
                        if ($('.wpg-wdp-top-bar').length) {
                            $('.wpg-wdp-top-bar').toggleClass('stuck');
                        }

                        let top = $('.wpg-wdp-top-bar').length ? $('.wpg-wdp-top-bar').outerHeight() : 0;

                        if (direction === 'down') {
                            $(selector).css({top: top});
                        } else {
                            $(selector).css({top: ($(selector).outerHeight() * -1)});
                        }
                    }

                    if ($(window).width() <= 1199) {
                        let bottom = 0;

                        if (direction === 'down') {
                            $(selector).css({bottom: bottom});
                        } else {
                            $(selector).css({bottom: -100});
                        }
                    }
                }, 
                offset: function() {
                    return $( '.wpg-wdp-product-sale-sticky_topbar' ).outerHeight() * -1;
                }
            });
        }

        if ($('.wdp-sticky-bar-top').length) {
            stickyBar();
        }

        $(window).resize(function() {
            if ($('.wdp-sticky-bar-top').length) {
                $('.wpg-wdp-sticky-bar').removeAttr("style");
                stickyBar();
            }
        });
    });
} catch (e) {}